<!-- <p>pharma-database-data-revisions-dropdown works!</p> -->
<div>
  <div nz-col id="dataview-filter" class="filter-holder" style="width: 123px">
    <label class="filter-label">Data/Revisions</label>
    <button
      nz-button
      nz-popover
      [nzPopoverBackdrop]="true"
      nzPopoverTrigger="click"
      [nzPopoverContent]="contentTemplate"
      nzPopoverPlacement="bottomLeft"
      [(nzPopoverVisible)]="dataViewFilterVisible"
      (nzPopoverVisible)="popoverChange()"
      class="filter-btn"
      style="width: 100%"
    >
      <span [innerHTML]="selectedDataView"></span>
      <span></span>
      <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="arrow"></i>
    </button>

    <ng-template #contentTemplate>
      <ul nz-menu class="list-style revision-option-list">
        <li nz-menu-item *ngIf="singleSelect">
          <nz-radio-group
            [(ngModel)]="viewBy"
            nzName="viewByOption"
            (ngModelChange)="chkboxOptChange()"
            *ngFor="let option of checkOptions"
          >
            <label nz-radio [nzValue]="option.value" class="radio-opt">
              {{ option.label }}
            </label>
          </nz-radio-group>
        </li>
        <li nz-menu-item *ngIf="!singleSelect">
          <nz-checkbox-group
            [(ngModel)]="checkOptions"
            (ngModelChange)="chkboxOptChange()"
          ></nz-checkbox-group>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item style="height: 90px">
          <nz-radio-group
            [(ngModel)]="radioValue"
            class="radio"
            (ngModelChange)="radioValChange()"
          >
            <label nz-radio nzValue="1m" class="radio-opt"
              >&Delta; 1 month</label
            >
            <label nz-radio nzValue="3m" class="radio-opt"
              >&Delta; 3 months</label
            >
            <label nz-radio nzValue="custom" class="radio-opt"
              ><span class="date-picker"
                >&Delta;
                <nz-date-picker
                  [(ngModel)]="customDate"
                  [nzDisabledDate]="disabledCustomDate"
                  (ngModelChange)="onDateChange()"
                  nzPlaceHolder="Custom Days"
                  [ngStyle]="{
                    'border-bottom': inValidCustomDate
                      ? '1px solid red'
                      : '1px solid #979797'
                  }"
                ></nz-date-picker></span
              ><i
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                style="color: red"
                *ngIf="inValidCustomDate"
              ></i
            ></label>
          </nz-radio-group>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item class="nib-filter-li">
          <div class="grid-control nib-filter">
            <div
              nz-col
              class="filter-holder revenue-type"
              style="max-height: 44px; margin-bottom: 4px"
            >
              <label
                nz-checkbox
                [(ngModel)]="showNIB"
                [nzDisabled]="showNIBControl"
                style="min-height: 40px"
              >
                Display and include consolidated drug revenue
                <br />
                in Total when indication revenue is unavailable
              </label>
            </div>
          </div>
        </li>
        <li nz-menu-divider></li>
        <li class="buttons">
          <div
            class="err-msg-holder"
            *ngIf="invalidDataview"
            style="width: 110px; line-height: 1"
          >
            <i
              nz-icon
              nzType="exclamation-circle"
              nzTheme="outline"
              style="color: red"
            ></i>
            <span class="err-msg">{{ dvErrMsg }}</span>
          </div>
          <div class="button-container">
            <button
              nz-button
              class="btn"
              (click)="onResetDataView()"
              *ngIf="showReset"
            >
              Reset
            </button>
            <button nz-button nzType="primary" (click)="applyDataView()">
              Apply
            </button>
          </div>
        </li>
      </ul>
    </ng-template>
  </div>

  <ng-template #popoverContentTemplate>
    <div>
      <span style="font-weight: 700">
        Include Consolidated-Only Revenues:
      </span>
      <br />
      <span>
        By default, the grid includes only drugs for which analyst forecasts
        provide revenue by indication. Enable this option to include drugs for
        which revenue by indication is unavailable to show combined revenue
        forecasts for the drug in the grid and in the sum line
      </span>
      <!-- <br /><br />
          <span style="text-wrap: wrap; word-break: break-all"
            >Turning off the toggle will show the total drug revenue in the grid and
            in the sum line.</span
          > -->
    </div>
  </ng-template>
</div>
